/**
 * Helpers: Accessibility
 * ------------------------------------------------------------------------------
 * - Basic accessibility helpers.
 */

/**
 * Handle key presses.
 * @param {Event} event
 */
function handleKeyDown(event) {

  /**
   * Only update state when the tab key is pressed.
   */
  if (event.keyCode === 9) {
    setKeyboardNavigation(true)
  }
}

/**
 * Handle mouse clicks and touch events.
 */
function handleMouseDown() {
  setKeyboardNavigation(false)
}

/**
 * Set a class on the body element and update the window object flag when
 * keyboard or mouse navigation is detected.
 * @param {Boolean} state
 */
function setKeyboardNavigation(state = false) {
  document.body.classList.toggle('is-keyboard-user', state)
  window.mint.accessibility.keyboardNavigation = state
}

/**
 * Set event listeners for mouse/touchscreen clicks and key presses.
 */
export function detectKeyboardNavigation() {
  window.addEventListener('mousedown', handleMouseDown, true)
  window.addEventListener('keydown', handleKeyDown, true)
}
